import React, { useState } from "react";
import "./ContactPage.css";
import { GetContactDetails } from "../../../services/contact.service";
import NullPageComponent from "../../../components/Tile/NullPageComponent";
import Button from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const [state, setState] = useState({
    loading: false,
    isSubmitted: false,
  });

  const [formStatus, setFormStatus] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus(null);
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const contactdata = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email.toLowerCase(),
        message: formData.message,
      };
      await GetContactDetails(contactdata);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
      });
      setState((prev) => ({
        ...prev,
        isSubmitted: true,
      }));
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setState(prev=>({...prev, loading:false}))
    }
  };

  return (
    <div className="container">
      {state.loading && (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      )}
      {state.isSubmitted ? (
        <div className="null-contact pb-5 d-md-flex d-block justify-content-center align-items-center py-4">
          <NullPageComponent
            heading1="Message sent"
            heading2="Thank you for your interest in Fan1."
            button1={
              <div className="d-block">
                <span className="font-500-26 line-120 continue-browsing-bg d-block mx-auto text-center tile3">
                  Continue Browsing
                </span>
                <div className="mt-4 d-flex d-md-block">
                  <Button
                    label="Go to Available Now"
                    className="btn"
                    onClick={() => navigate("/available")}
                    variant="dark"
                  />
                  <Button
                    label="Check out Rankings"
                    className="btn ms-3"
                    onClick={() => navigate("/rankings")}
                    variant="dark"
                  />
                </div>
              </div>
            }
          />
        </div>
      ) : (
        <div className="py-5 d-md-flex d-block justify-content-center align-items-center">
          <div className="contact-page d-flex flex-column flex-md-row mb-4 mb-md-0 position-relative overflow-hidden">
            {/* Left Side */}
            <div className="contact-left">
              <h1 className="font-500-44 mb-3 contact-head">Contact Us</h1>
              <div className="mb-5">
                <span className="font-500-26 d-block mb-2 contact-tile">
                  Have questions or need assistance?
                </span>
                <div className="font-300-15 contact-tile2">
                  Fill out the form, and we’ll get back to you as soon as
                  possible.
                </div>
              </div>

              <div className="mb-4 d-none d-md-block">
                <div>
                  <span className="font-500-20 d-block">Mailing Address</span>
                  <div className="font-300-15">
                    19125 North Creek Pkwy
                    <br />
                    Suite 120 PMB 675
                    <br />
                    Bothell, WA 98011
                  </div>
                </div>
                <div className="mt-3">
                  <span className="font-500-20">Phone</span>
                  <div className="font-300-15">(888) 707-FAN1</div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="contact-right">
              {formStatus && (
                <div className="alert alert-danger">{formStatus}</div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column flex-md-row gap-3">
                  <div>
                    <label className="font-400-14 d-block mb-2">
                      <span>First Name</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      className="form-control application-form-control"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="Enter your first name"
                      required
                    />
                  </div>
                  <div>
                    <label className="font-400-14 d-block mb-2">
                      <span>Last Name</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      className="form-control application-form-control"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Enter your last name"
                      required
                    />
                  </div>
                </div>

                <div className="mt-3 z-1">
                  <label className="font-400-14 d-block mb-2">
                    <span>Email</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control application-form-control"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="mb-4 mt-3 z-1">
                  <label className="font-400-14 d-block mb-2">
                    <span>Your Message</span>
                  </label>
                  <textarea
                    name="message"
                    className="form-control application-form-control"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Enter your message"
                    rows={5}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-50 text-black font-500-18 z-1"
                >
                  Send Message
                </button>
              </form>
              <div className="contact-right-ellipse"/>
            </div>
          </div>

          {/* Mobile Contact Info */}
          <div className="mb-4 d-block d-md-none contact-tile3">
            <div>
              <span className="font-500-20 d-block">Mailing Address</span>
              <div className="font-300-15">
                19125 North Creek Pkwy
                <br />
                Suite 120 PMB 675
                <br />
                Bothell, WA 98011
              </div>
            </div>
            <div className="mt-3">
              <span className="font-500-20">Phone</span>
              <div className="font-300-15">(888) 707-FAN1</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactPage;
